import { useEffect, useReducer } from 'react';

export interface TimerState {
  isActive: boolean;
  isPaused: boolean;
  baseElapsedMs: number;
  segmentStartTime: number | null;
}

export const computeElapsedSeconds = ({
  isActive,
  isPaused,
  baseElapsedMs,
  segmentStartTime,
}: TimerState): number => {
  if (!isActive) return 0;

  if (isPaused) {
    return Math.floor(baseElapsedMs / 1000);
  }

  const segmentMs = segmentStartTime ? Date.now() - segmentStartTime : 0;

  return Math.floor((baseElapsedMs + segmentMs) / 1000);
};

export const useTimer = (state: TimerState) => {
  const [, forceRender] = useReducer((count) => count + 1, 0);

  useEffect(() => {
    if (!state.isActive || state.isPaused) {
      return;
    }

    const intervalId = setInterval(() => {
      forceRender();
    }, 1000);

    return () => clearInterval(intervalId);
  }, [state.isActive, state.isPaused]);

  return computeElapsedSeconds(state);
};
